import React from "react";
import {CaptionStepComponent, FullCaptionComponent} from "../../../../../app/components/caption/CaptionComponent";
import {CodeComponent} from "../../../../../app/components/code/CodeComponent";

export function HashSetInsert17FullCaption() {
    return (<FullCaptionComponent title="VALUE: 17">
        <HashSetInsert171/>
        <HashSetInsert172/>
        <HashSetInsert173/>
        <HashSetInsert174/>
        <HashSetInsert175/>
    </FullCaptionComponent>)
}

export function HashSetInsert171() {
    return (<CaptionStepComponent
        title={<h6>1. Check if our <CodeComponent className="codeValue">VALUE</CodeComponent> is
            unique. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>HashSets only contain unique <CodeComponent className="codeValue">VALUES</CodeComponent>. We should first
            call our <CodeComponent>contains</CodeComponent> function to make sure we don't already have a 17 in our
            HashSet. In this case, we do not already have 17, so we are good to continue.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert172() {
    const generateHashFunction = "fun generateHash(value: Int): Int {return value % arraySize}"
    return (<CaptionStepComponent title={<h6>2. Generate <CodeComponent
        className="codeHash">HASH</CodeComponent>. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Assuming our hash function is <CodeComponent>{generateHashFunction}</CodeComponent>, if we input 17, we
            output a <CodeComponent className="codeHash">HASH</CodeComponent> of 1.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert173() {
    return (<CaptionStepComponent title={<h6>3. Find sub-collection at the <CodeComponent
        className="codeHash">HASH</CodeComponent> index. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Because our <CodeComponent className="codeHash">HASH</CodeComponent> is 1, we now want to find the
            sub-collection at index 1 of our array. Here, we see we found our first collision. We already have an item
            in our sub-collection. A previous <CodeComponent className="codeValue">VALUE</CodeComponent> of 1 can be
            found at <CodeComponent className="codeHash">HASH</CodeComponent>1.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert174() {
    return (<CaptionStepComponent
        title={<h6>4. Insert <CodeComponent className="codeValue">VALUE</CodeComponent> into the
            sub-collection. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>We now want to add our new <CodeComponent className="codeValue">VALUE</CodeComponent> of 17 to our HashSet.
            Again, see above for multiple ways to handle collisions, but in our case, we are going to simply add our
            new <CodeComponent className="codeValue">VALUE</CodeComponent> of 17 to our sub-collection found at index 1.
            This may look something like <CodeComponent>arr[HASH].add(VALUE)</CodeComponent>. As you can see, we are
            using a 2D-array to keep track of our HashSet in order to eloquently handle collisions. There
            is <i>always</i> a chance of collisions happening, so always be prepared to handle them. In this case, we
            were prepared by always having a sub-collection at each index.</p>
    </CaptionStepComponent>)
}

export function HashSetInsert175() {
    return (<CaptionStepComponent title={<h6>5. If necessary, increase HashSet space to maintain an optimal
        balance. <CodeComponent><s>O(n)</s></CodeComponent> <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Because we only have 6 out of 16 slots, or 37.5% of our slots filled, we do <i>not</i> need to increase our
            space. We skip this step for now.</p>
    </CaptionStepComponent>)
}
